import compose from 'compose-function';

const upperFirst = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);
const upperCapital = (s: string) => s.split(' ').map(upperFirst).join(' ');
const lower = (s: string) => s.toLowerCase();

export const capitalize = compose(upperCapital, lower);

